import Content from './content-interface';

export default class SetInstanceDeletedHistory implements Content {
  instance: string;

  constructor(obj: any = {}) {
    this.instance = obj.instance || '';
  }

  public static of(obj: any = {}): SetInstanceDeletedHistory {
    return new SetInstanceDeletedHistory(obj);
  }
}
